module.exports = __webpack_public_path__ + "images/borent645cae67bc7d8729307b60b12eb904ca.png";